import React from 'react';
import i18n from 'i18n';
import styled from 'styled-components/macro';
import scaleSize from 'utils/scale-size';
import Platform from 'platform';
import { useSelector } from 'react-redux';
import { getIsLifecellFlag } from 'reducers/profile/selectors';

const StyledSupportInfoWrapper = styled.div`
  margin-left: ${scaleSize(40)}px;
  position: absolute;
  display: flex;
  justify-content: space-between;
  width: ${({ isLifecellUser }) => (isLifecellUser ? `${scaleSize(1590)}px` : 'auto')};
  bottom: ${scaleSize(90)}px;
  left: ${scaleSize(180)}px;
`;

const StyledSupportInfoSection = styled.div`
  display: inline-block;
  font-family: 'RobotoRegular', sans-serif;
  font-weight: 500;
  letter-spacing: ${scaleSize(-0.21)}px;
  font-size: ${scaleSize(30)}px;

  position: relative;
  bottom: ${scaleSize(0)}px;
  vertical-align: top;

  &:first-child {
    margin-right: ${scaleSize(110)}px;
  }

  &:last-child {
    text-align: right;
  }

  & > div {
    height: ${scaleSize(40)}px;
    margin-bottom: ${scaleSize(32)}px;
    line-height: 1.33;
    color: ${({ theme }) => theme.secondaryTextColor};
  }

  & > span {
    color: ${({ theme }) => theme.mainTextColor};
    margin-right: ${scaleSize(40)}px;

    &:last-child {
      margin-right: 0;
    }
  }
`;

const StyledLegalSection = styled.div`
  position: absolute;
  bottom: ${scaleSize(-40)}px;
  left: 0;
  font-size: ${scaleSize(16)}px;
  opacity: 0.75;
`;

const CONTACTS = {
  VOLIA: [
    i18n.t('profile.support.phone1'),
    i18n.t('profile.support.phone2'),
    i18n.t('profile.support.phone3'),
    i18n.t('profile.support.email'),
  ],
  LIFECELL: ['5433', '0 800 20 5433'],
};

export const SupportInfo = () => {
  const isLifecellUser = useSelector(getIsLifecellFlag);
  const appVersion = Platform.getAppVersion();

  return (
    <StyledSupportInfoWrapper isLifecellUser={isLifecellUser}>
      <StyledSupportInfoSection>
        <div>{i18n.t('profile.support.title')}</div>
        {CONTACTS[isLifecellUser ? 'LIFECELL' : 'VOLIA'].map((text, i) => (
          <span key={i}>{text}</span>
        ))}
      </StyledSupportInfoSection>
      <StyledSupportInfoSection>
        <div>{i18n.t('profile.version')}</div>
        <span>{appVersion}</span>
      </StyledSupportInfoSection>
      <StyledLegalSection>
        <div>{i18n.t('profile.legal_structure')}</div>
      </StyledLegalSection>
    </StyledSupportInfoWrapper>
  );
};
